var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbCircleSummer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.105 12.6223C25.105 5.69547 19.4858 0.081543 12.5525 0.081543C5.61922 0.081543 0 5.69547 0 12.6223C0 19.549 5.61922 25.163 12.5525 25.163C12.6261 25.163 12.6996 25.163 12.7732 25.1581V15.3998H10.0763V12.2598H12.7732V9.94756C12.7732 7.26796 14.4109 5.80814 16.8037 5.80814C17.9511 5.80814 18.9367 5.89142 19.221 5.93061V8.73268H17.5735C16.2741 8.73268 16.0192 9.34992 16.0192 10.2562V12.2549H19.1328L18.7258 15.3949H16.0192V24.678C21.2657 23.1741 25.105 18.3489 25.105 12.6223Z",
    fill: "#5C5A9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbCircleSummer);
export default __webpack_public_path__ + "static/media/FB-circle-summer.5f235c05097700810ecf5bba0cd4c8a2.svg";
export { ForwardRef as ReactComponent };